'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  CMS: 'cms',
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  GROWTH_SUITE: 'growth-suite',
  CRM: 'crm'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/ProductsAndPlansNavIds.js
// module id = 85
// module chunks = 3 4